// import React from "react";
// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
//   const isAuthenticated = useSelector(
//     (state: any) => state.auth.isAuthenticated
//   );

//   if (!isAuthenticated) {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;

import { Navigate } from "react-router-dom";
import { AuthenticationLayout } from "../Layout/authentication/AuthenticationLayout";
import { getClientConfig } from "../config/clientConfig";

const PublicRoute = ({ children }: { children: JSX.Element }) => {
  // alert("public route");
  const clientConfig = getClientConfig();
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  // if (isAuthenticated) {
  //   return <Navigate to="/home" replace />;
  // }

  return (
    <AuthenticationLayout clientConfig={clientConfig}>
      {children}
    </AuthenticationLayout>
  );
};

export default PublicRoute;
